export enum DialogType {
  Error = 'error',
  Information = 'info',
  Warning = 'warning',
}
